import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os dados do município
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getDados(cod_ibge, nu_ine, publico_alvo) {
  try {
    const { data } = await api.get(
      '/app/campanha-gripe/publico-alvo/' +
        cod_ibge +
        '/' +
        nu_ine +
        '/' +
        publico_alvo
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export function exibirVermelhos(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (item.dt_aplicacao_br !== null) {
      let dateSplit = item.dt_aplicacao_br.split('/')
      if (Number(dateSplit[2]) == Number(new Date().getFullYear())) {
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (item.dt_aplicacao_br !== null) {
      let dateSplit = item.dt_aplicacao_br.split('/')
      if (Number(dateSplit[2]) == Number(new Date().getFullYear())) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  })
  return filtro
}

export function generatePdf(
  cadastros,
  selectEquipe,
  selectProfissional,
  nomeProfissional,
  publicoAlvo
) {
  const titlePdf = 'Campanha gripe'
  const titlePdfSave = utils.methods.titlePdf(titlePdf, selectEquipe.no_equipe)
  const descriptionPdf =
    'Público alvo a ser vacinado na campanha contra a gripe no ano atual'
  const headersPdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'MA',
    'INFLUENZA TRIVALENTE',
    'DOCUMENTO',
  ]

  const dataPdf = cadastros.map((item) => {
    const documentos = []
    if (item.nu_cpf) documentos.push(`CPF ${item.nu_cpf}`)
    if (item.nu_cns) documentos.push(`CNS ${item.nu_cns}`)

    return {
      no_cidadao: item.no_cidadao,
      dt_nascimento: item.dt_nascimento_br,
      no_mae: item.no_mae,
      micro_area: item.micro_area,
      dt_aplicacao_br: item.dt_aplicacao_br,
      documento: documentos.join('\n'),
    }
  })

  const table = utils.methods.createTablePdf(dataPdf)
  const doc = new jsPDF(utils.methods.encryptionPdf())

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64Brasao) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64Brasao,
        titlePdf,
        descriptionPdf
      )

      const equipeInfo = [
        { label: 'Equipe', value: selectEquipe.no_equipe },
        { label: 'CNES', value: selectEquipe.nu_cnes },
        { label: 'INE', value: selectEquipe.nu_ine },
        { label: 'Profissional ACS', value: nomeProfissional },
        { label: 'Público alvo', value: publicoAlvo.label },
      ]

      verticalPosition = utils.methods.bodyPdf(
        doc,
        equipeInfo,
        verticalPosition
      )

      const anoAtual = new Date().getFullYear()

      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: ({ row, section }) => {
          if (section === 'head') {
            doc.setTextColor(0, 0, 0)
            return
          }

          const dataAplicacao = row.raw[4]
          const cor =
            dataAplicacao && dataAplicacao.split('/')[2] === String(anoAtual)
              ? [2, 99, 57] // verde
              : [194, 10, 16] // vermelho

          doc.setTextColor(...cor)
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
